import React from 'react';

export const name = 'flag-LV';

export const FlagLV = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2_330)">
      <mask
        id="mask0_2_330"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <path d="M24 0H0V24H24V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_2_330)">
        <path
          d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
          fill="#EEEEEE"
        />
        <path
          d="M12 4.35419e-07C9.36235 -0.00070987 6.79796 0.867647 4.70335 2.47077C2.6088 4.0739 1.10077 6.32245 0.412506 8.86875H23.5875C22.8985 6.32287 21.3903 4.07474 19.2959 2.47174C17.2015 0.86873 14.6375 7.8757e-05 12 4.35419e-07ZM12 24C14.6377 24.0007 17.2021 23.1323 19.2967 21.5292C21.3912 19.9261 22.8992 17.6775 23.5875 15.1312H0.412506C1.10077 17.6775 2.6088 19.9261 4.70335 21.5292C6.79796 23.1323 9.36235 24.0007 12 24Z"
          fill="#A2001D"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_2_330">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
